// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pPF4","colBig":"styles_colBig__knefW","colSmall":"styles_colSmall__1XqY6"};